import cx from 'classnames';
import { TabsList as MUITabsList } from '@mui/base';
import { type ReactNode } from 'react';
import styles from './TabsList.scss';

export const TabsList = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <MUITabsList className={cx(styles.tabList, className)}>
    {children}
  </MUITabsList>
);
